import React, {
    useState,
    useEffect
}
from "react";

import LeftMenuIcon
from "../components/LeftMenuIcon";

import LeftMenuIconFilter
from "../components/LeftMenuIconFilter";


import evaImage
from "../pages/eva/images/eva_person.png";

import EvaChat
from "../pages/eva/ai/EvaChat";

import {
    useHistory
}
from "react-router-dom";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faBars,
    faTimes,
    faHome,
    faUser,
    faQuestionCircle,
    faHeart,
    faPaperclip,
    faArrowLeft,
    faCogs,
    faKey,
    faSignOutAlt,
    faCube
}
from "@fortawesome/free-solid-svg-icons";

import BlurredBackdropModal
from "../components/BlurredBackdropModal";

import ChangePasswordCard
from "../components/ChangePasswordCard";

import {
    functions
}
from "../constants/common-functions";

import {
    SYSTEM_ROLE_SUPERADMIN,
    SYSTEM_ROLE_ADMIN
}
from "../constants/general-constants";

import {
    NAV_GRADIENT
}
from "../constants/colors";

import omniscanLogo
from "../../images/omniscanlogo_dark.png";


export default function LeftMenu({
    showFilter
})
{
    //--------------------------------------------------------
    // Router
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [highlightId, setHighlightId] =
        useState("1");

    const [showUserMenu, setShowUserMenu] =
        useState(false);

    const [showChangePassword, setShowChangePassword] =
        useState(false);

    const [showAdminIcon, setShowAdminIcon] =
        useState(false);

    const [showMobileMenu, setShowMobileMenu] =
        useState(false);
		
	const [showEva, setShowEva] =
	    useState(false);
		
		
	//--------------------------------------------------------
	// Open Eva
	//--------------------------------------------------------

	const openEva =
	    () =>
	    {
	        closeMobileMenu();

	        setShowEva(true);
	    };


    //--------------------------------------------------------
    // Load user
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/getuser",
                null,
                handleUser
            );
        },
        []
    );


    //--------------------------------------------------------
    // Handle user
    //--------------------------------------------------------

    const handleUser =
        (user) =>
        {
            if (!user)
            {
                return;
            }

            const isAdmin =
                user.roles.includes(
                    SYSTEM_ROLE_SUPERADMIN
                )
                ||
                user.roles.includes(
                    SYSTEM_ROLE_ADMIN
                );

            setShowAdminIcon(
                isAdmin
            );

            const isAdminUrl =
                window.location.pathname.includes(
                    "administration"
                );

            if (!isAdmin &&
                isAdminUrl)
            {
                history.push(
                    "/home"
                );
            }
        };


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const closeMobileMenu =
        () =>
        {
            setShowMobileMenu(false);
            setShowUserMenu(false);
        };


    const goHome =
        () =>
        {
            closeMobileMenu();

            history.push(
                "/home"
            );
        };


    const goEva =
        () =>
        {
            closeMobileMenu();

            history.push(
                "/eva"
            );
        };


    const goUpload =
        () =>
        {
            closeMobileMenu();

            history.push(
                "/uploadfile"
            );
        };


    const goAdministration =
        () =>
        {
            closeMobileMenu();

            history.push(
                "/administrationhome"
            );
        };


    const goLogout =
        () =>
        {
            closeMobileMenu();

            history.push(
                "/logout"
            );
        };


    const goBack =
        () =>
        {
            closeMobileMenu();

            if (
                document.location.href.indexOf(
                    "utilisationallnonstandard"
                ) > -1
            )
            {
                history.push(
                    "/map/-100"
                );
            }
            else
            {
                history.goBack();
            }
        };


    //--------------------------------------------------------
    // Profile
    //--------------------------------------------------------

    const changePassword =
        () =>
        {
            setShowUserMenu(false);
            setShowMobileMenu(false);
            setShowChangePassword(true);
        };


    const handleProfileClick =
        () =>
        {
            setShowUserMenu(
                !showUserMenu
            );
        };


    const handleMouseLeaveMenu =
        () =>
        {
            setShowUserMenu(false);
        };


    //--------------------------------------------------------
    // Desktop menu
    //--------------------------------------------------------

    const leftMenuIcons =
    [
        {
            id: "1",
            icon: "home",
            clickFunction: goHome,
            label: "Home"
        },
        {
            id: "2",
            icon: "user",
            clickFunction: handleProfileClick,
            label: "Profile"
        },
        {
            id: "3",
            icon: "question",
            clickFunction: () => {},
            label: "Help"
        },
        {
            id: "4",
            icon: "heart",
            clickFunction: () => {},
            label: "Add"
        },
        {
            id: "6",
            icon: "paperclip",
            clickFunction: goUpload,
            label: "Upload"
        },
        {
            id: "5",
            icon: "arrow-left",
            clickFunction: goBack,
            label: "Back"
        }
    ];


    //--------------------------------------------------------
    // Mobile menu
    //--------------------------------------------------------

    const mobileMenuItems =
    [
        {
            id: "home",
            icon: faHome,
            label: "Home",
            clickFunction: goHome
        },
        {
            id: "profile",
            icon: faUser,
            label: "Profile",
            clickFunction: handleProfileClick
        },
        {
            id: "eva",
            icon: faCube,
            label: "EVA",
            clickFunction: goEva,
            eva: true
        },
        {
            id: "help",
            icon: faQuestionCircle,
            label: "Help",
            clickFunction: () => {}
        },
        {
            id: "add",
            icon: faHeart,
            label: "Add",
            clickFunction: () => {}
        },
        {
            id: "upload",
            icon: faPaperclip,
            label: "Upload",
            clickFunction: goUpload
        },
        {
            id: "back",
            icon: faArrowLeft,
            label: "Back",
            clickFunction: goBack
        }
    ];


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (
        <>

            {/* ================================================
                DESKTOP NAVIGATION
            ================================================= */}

            <div
                className="omniscan-desktop-menu"
                style={desktopContainerStyle}
            >

                {
                    leftMenuIcons.map(
                        (item) =>
                        {
                            return (
                                <LeftMenuIcon
                                    key={item.id}
                                    id={item.id}
                                    icon={item.icon}
                                    clickFunction={
                                        item.clickFunction
                                    }
                                    highlightId={
                                        highlightId
                                    }
                                    label={item.label}
                                />
                            );
                        }
                    )
                }

                {
                    showFilter
                    &&
                    <LeftMenuIconFilter />
                }

                {
                    showAdminIcon
                    &&
                    <LeftMenuIcon
                        id="admin"
                        icon="cogs"
                        clickFunction={
                            goAdministration
                        }
                        highlightId={
                            highlightId
                        }
                        label="Admin"
                    />
                }
				
				
				<div
				    onClick={openEva}
				    title="Eva"
				    style={{
				        width: "46px",
				        height: "46px",

				        marginTop: "auto",
				        marginBottom: "12px",

				        display: "flex",
				        alignItems: "flex-end",
				        justifyContent: "center",

				        background:
				            "linear-gradient(145deg, #4b286d, #29153f)",

						border: "1px solid rgba(255,255,255,0.35)",
						borderRadius: "55%",

				        cursor: "pointer",
				        overflow: "hidden",

				        boxShadow:
				            "0 3px 10px rgba(0,0,0,0.35)"
				    }}
				>
				    <img
				        src={evaImage}
				        alt="Eva"
				        style={{
				            width: "44px",
				            height: "44px",
				            objectFit: "contain",
				            objectPosition: "center bottom"
				        }}
				    />
				</div>


                {/* --------------------------------------------
                    Desktop profile popout
                --------------------------------------------- */}

                {
                    showUserMenu
                    &&
                    <div
                        onMouseLeave={
                            handleMouseLeaveMenu
                        }
                        style={desktopUserMenuStyle}
                    >

                        <div
                            style={menuItemDark}
                            onClick={
                                changePassword
                            }
                            onMouseEnter={
                                hoverOn
                            }
                            onMouseLeave={
                                hoverOff
                            }
                        >
                            <FontAwesomeIcon
                                icon={faKey}
                                style={menuIconDark}
                            />

                            Change Password
                        </div>

                        <div
                            style={{
                                ...menuItemDark,
                                borderBottom: "none",
                                color: "#ff6b6b"
                            }}
                            onClick={
                                goLogout
                            }
                            onMouseEnter={
                                hoverOn
                            }
                            onMouseLeave={
                                hoverOff
                            }
                        >
                            <FontAwesomeIcon
                                icon={faSignOutAlt}
                                style={menuIconDark}
                            />

                            Log Out
                        </div>

                    </div>
                }

            </div>


            {/* ================================================
                MOBILE HEADER
            ================================================= */}

            <header
                className="omniscan-mobile-header"
            >

                <img
                    src={omniscanLogo}
                    alt="OmniScan Pro"
                    className="omniscan-mobile-logo"
                    onClick={goHome}
                />

                <button
                    type="button"
                    className="omniscan-mobile-menu-button"
                    onClick={
                        () =>
                        {
                            setShowMobileMenu(
                                true
                            );
                        }
                    }
                    aria-label="Open menu"
                >
                    <FontAwesomeIcon
                        icon={faBars}
                    />
                </button>

            </header>


            {/* ================================================
                MOBILE DRAWER
            ================================================= */}

            {
                showMobileMenu
                &&
                <>
                    <div
                        className="omniscan-mobile-menu-backdrop"
                        onClick={
                            closeMobileMenu
                        }
                    />

                    <aside
                        className="omniscan-mobile-menu"
                    >

                        {/* Header */}

                        <div
                            className="omniscan-mobile-menu-header"
                        >

                            <img
                                src={omniscanLogo}
                                alt="OmniScan Pro"
                            />

                            <button
                                type="button"
                                onClick={
                                    closeMobileMenu
                                }
                                aria-label="Close menu"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                />
                            </button>

                        </div>


                        {/* Main navigation */}

                        <div
                            className="omniscan-mobile-menu-items"
                        >

                            {
                                mobileMenuItems.map(
                                    (item) =>
                                    {
                                        return (
                                            <div
                                                key={item.id}
                                                className={
                                                    item.eva
                                                        ?
                                                        "omniscan-mobile-menu-item omniscan-mobile-menu-eva"
                                                        :
                                                        "omniscan-mobile-menu-item"
                                                }
                                                onClick={
                                                    item.clickFunction
                                                }
                                            >

                                                <div
                                                    className="omniscan-mobile-menu-icon"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={
                                                            item.icon
                                                        }
                                                    />
                                                </div>

                                                <span>
                                                    {item.label}
                                                </span>

                                            </div>
                                        );
                                    }
                                )
                            }


                            {
                                showAdminIcon
                                &&
                                <div
                                    className="omniscan-mobile-menu-item"
                                    onClick={
                                        goAdministration
                                    }
                                >

                                    <div
                                        className="omniscan-mobile-menu-icon"
                                    >
                                        <FontAwesomeIcon
                                            icon={faCogs}
                                        />
                                    </div>

                                    <span>
                                        Admin
                                    </span>

                                </div>
                            }

                        </div>


                        {/* ------------------------------------
                            User actions
                        ------------------------------------- */}

                        <div
                            className="omniscan-mobile-user-actions"
                        >

                            <div
                                onClick={
                                    changePassword
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faKey}
                                />

                                <span>
                                    Change Password
                                </span>
                            </div>

                            <div
                                className="omniscan-mobile-logout"
                                onClick={
                                    goLogout
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faSignOutAlt}
                                />

                                <span>
                                    Log Out
                                </span>
                            </div>

                        </div>

                    </aside>
                </>
            }


            {/* ================================================
                CHANGE PASSWORD
            ================================================= */}

            <BlurredBackdropModal
                show={showChangePassword}
                onClose={
                    () =>
                    {
                        setShowChangePassword(
                            false
                        );
                    }
                }
            >
                <ChangePasswordCard
                    onClose={
                        () =>
                        {
                            setShowChangePassword(
                                false
                            );
                        }
                    }
                />
            </BlurredBackdropModal>
			
			{/* ================================================
			    EVA CHAT
			================================================= */}

			<EvaChat
			    visible={showEva}
			    onClose={
			        () =>
			        {
			            setShowEva(false);
			        }
			    }
			/>

        </>
    );
}


//============================================================
// Desktop styles
//============================================================

const desktopContainerStyle =
{
    display: "flex",

    alignItems: "center",

    position: "fixed",

    left: "0px",
    top: "0px",

    width: "60px",

    bottom: "0px",

    flexDirection: "column",

    paddingTop: "10px",

    background: "#090b0d",

    borderRight:
        "1px solid rgba(255,255,255,0.06)",

    boxShadow: "none",

    zIndex: 20
};


const desktopUserMenuStyle =
{
    position: "absolute",
    left: "60px",
    top: "90px",
    width: "210px",
    background:
        "linear-gradient(180deg, #1F1F21 0%, #2A2C31 100%)",
    borderRadius: "8px",
    boxShadow:
        "0 8px 24px rgba(0,0,0,0.4)",
    overflow: "hidden",
    zIndex: 30
};


//============================================================
// User menu
//============================================================

const menuItemDark =
{
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "12px",
    color: "#ffffff",
    borderBottom:
        "1px solid rgba(255,255,255,0.08)",
    transition:
        "background 0.2s ease"
};


const menuIconDark =
{
    marginRight: "12px",
    width: "16px",
    opacity: 0.9
};


const hoverOn =
    (e) =>
    {
        e.currentTarget.style.background =
            "linear-gradient(180deg, #2A2C31 0%, #35373D 100%)";
    };


const hoverOff =
    (e) =>
    {
        e.currentTarget.style.background =
            "transparent";
    };